import { createContext, useContext } from 'react'

import { AnyRouter, RouteApi } from '@tanstack/react-router'

import { AlertsReportResponse } from '../types'

type AlertsReportContextValue = {
  data: AlertsReportResponse
  isFetching: boolean
  routeApi: RouteApi<'/_app/reports/alerts', AnyRouter>
}

export const AlertsReportContext = createContext<AlertsReportContextValue | null>(null)

export const useAlertsReportContext = () => {
  const context = useContext(AlertsReportContext)
  if (!context) {
    throw new Error('useAlertsReportContext must be used within a AlertsReportContext.Provider')
  }
  return context
}
